import { createClient } from 'contentful';

const client = createClient({
    space: 'u0m2r30rgcr8',
    accessToken: 'SVi5vartw7ozoA9tjaU6JCTeiZ6Qzl0EoMVWYhPfs3Y',
});

export default client;